function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "page", "itemCount", "itemsPerPage", "showItemsPerPage", "withWords", "visualLabels", "a11yLabels", "aria-live", "itemsPerPageOptions", "onChange", "aria-label"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-int.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef, useState } from 'react';
import { uniqueId } from '@lmig/lmds-helpers';
import { Select, SelectOption } from '@lmig/lmds-react-select';
import { Link } from '@lmig/lmds-react-link';
import { IconButton } from '@lmig/lmds-react-icons';
import { useMinBreakpoint } from '@lmig/lmds-react-floating-header/dist/hooks/useMinBreakpoint';
import IconTabsCaretLeft from '@lmig/lmds-react-icons/dist/icons/TabsCaretLeft';
import IconTabsCaretRight from '@lmig/lmds-react-icons/dist/icons/TabsCaretRight';
import classNames from 'classnames';
import "./pagination.css";
/**
 * @see [LMDS Pagination Documentation and Examples](https://designsystem.lmig.com/components/pagination/code)
 *
 * API:
 *
 * @implements [PaginationProps](https://designsystem.lmig.com/components/pagination/code#pagination-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */

var defaultVisualLabels = {
  next: 'next',
  previous: 'previous',
  perPage: 'Items per page'
};
var defaultA11yLabels = {
  next: 'Next page',
  previous: 'Previous page',
  page: 'Page'
};
export var Pagination = function Pagination(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 0 : _ref$page,
    itemCount = _ref.itemCount,
    _ref$itemsPerPage = _ref.itemsPerPage,
    itemsPerPage = _ref$itemsPerPage === void 0 ? 10 : _ref$itemsPerPage,
    _ref$showItemsPerPage = _ref.showItemsPerPage,
    showItemsPerPage = _ref$showItemsPerPage === void 0 ? true : _ref$showItemsPerPage,
    _ref$withWords = _ref.withWords,
    withWords = _ref$withWords === void 0 ? true : _ref$withWords,
    _ref$visualLabels = _ref.visualLabels,
    visualLabels = _ref$visualLabels === void 0 ? defaultVisualLabels : _ref$visualLabels,
    customA11yLabels = _ref.a11yLabels,
    _ref$ariaLive = _ref['aria-live'],
    ariaLive = _ref$ariaLive === void 0 ? 'polite' : _ref$ariaLive,
    _ref$itemsPerPageOpti = _ref.itemsPerPageOptions,
    itemsPerPageOptions = _ref$itemsPerPageOpti === void 0 ? [10, 25, 50] : _ref$itemsPerPageOpti,
    onChange = _ref.onChange,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Pagination' : _ref$ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(function () {
      return id || uniqueId('pagination');
    }),
    _useState2 = _slicedToArray(_useState, 1),
    uniqueID = _useState2[0];
  var navPagesRef = useRef(null);
  var _useState3 = useState({
      top: null,
      left: null,
      width: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    activePosition = _useState4[0],
    setActivePosition = _useState4[1];
  var showWords = useMinBreakpoint('sm') && withWords;
  useEffect(function () {
    if (!(navPagesRef !== null && navPagesRef !== void 0 && navPagesRef.current) || showWords === null) return;
    // This gets the current button within the nav pages ref.
    // Need to set the top property because on mobile screens, the nav page buttons can wrap, and if we set bottom: 0, then it will display away from active button.
    var current = navPagesRef.current;
    var activeButton = current.querySelector('[aria-current=true]');
    // This is getting the height of the highlight span, to use it as an offset to the height for the top property mentioned above.
    var currentHighlight = current.querySelector('.lmig-Pagination-nav-pages--highlight');
    var _currentHighlight$get = currentHighlight.getBoundingClientRect(),
      highlightHeight = _currentHighlight$get.height;
    var offsetLeft = activeButton.offsetLeft;
    var _activeButton$getBoun = activeButton.getBoundingClientRect(),
      width = _activeButton$getBoun.width,
      height = _activeButton$getBoun.height;
    setActivePosition({
      left: offsetLeft,
      top: height - highlightHeight,
      width: width
    });
  }, [navPagesRef, page, showWords]);
  var handlePageChange = function handlePageChange(e, newPage, newItemsPerPage) {
    if (typeof onChange === 'undefined') return;
    var firstItemIndex = page * itemsPerPage;
    var newActivePageIndex = Math.floor(firstItemIndex / newItemsPerPage);
    var paginationChangeEvent = {
      originalEvent: e,
      // DOM event that triggered the change
      page: itemsPerPage !== newItemsPerPage ? newActivePageIndex : newPage,
      // Index of selected page
      itemsPerPage: newItemsPerPage // Selected items per page
    };
    onChange(paginationChangeEvent);
  };
  var allVisualLabels = _objectSpread(_objectSpread({}, defaultVisualLabels), visualLabels);
  var allA11yLabels = _objectSpread(_objectSpread({}, defaultA11yLabels), customA11yLabels);
  var totalPages = Math.ceil(itemCount / itemsPerPage);
  var totalPageArray = Array(totalPages).fill(null);

  // This code calculates the Array of pages to show
  var pageArray = function pageArray() {
    if (totalPageArray.length <= 5) {
      // short list code (<= 5 items)
      return totalPageArray.map(function (pageNum, i) {
        return i + 1;
      });
    }
    // long list code (> 5 items)
    if (page <= 2) {
      return [1, 2, 3, '...', totalPageArray.length];
    }
    if (page >= totalPageArray.length - 3) {
      return [1, '...', totalPageArray.length - 2, totalPageArray.length - 1, totalPageArray.length];
    }
    return [1, '...', page + 1, '...', totalPageArray.length];
  };
  var getButtons = function getButtons(direction) {
    // when withWords is true and the breakpoint is larger than BREAKPOINTS[0] then use words. If not return icons
    return showWords ?
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React.createElement(Link, {
      className: "lmig-Pagination-nav-pages-controlButton lmig-Pagination-nav-pages-controlButton--".concat(direction),
      type: "button",
      variant: "standalone",
      caretPosition: direction === 'previous' ? 'left' : 'right',
      disabled: direction === 'previous' ? page <= 0 : page >= totalPages - 1,
      onClick: function onClick(e) {
        return handlePageChange(e, direction === 'previous' ? page - 1 : page + 1, itemsPerPage);
      },
      "aria-label": customA11yLabels && direction in customA11yLabels ? customA11yLabels[direction] : undefined
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": customA11yLabels && direction in customA11yLabels ? true : undefined
    }, allVisualLabels[direction])) : /*#__PURE__*/React.createElement(IconButton, {
      initialSize: "16",
      className: "lmig-Pagination-nav-pages-controlButton lmig-Pagination-nav-pages-controlButton--".concat(direction),
      disabled: direction === 'previous' ? page <= 0 : page >= totalPages - 1,
      onClick: function onClick(e) {
        return handlePageChange(e, direction === 'previous' ? page - 1 : page + 1, itemsPerPage);
      }
    }, direction === 'previous' ? /*#__PURE__*/React.createElement(IconTabsCaretLeft, {
      color: "teal",
      title: allA11yLabels[direction],
      "aria-hidden": "false"
    }) : /*#__PURE__*/React.createElement(IconTabsCaretRight, {
      color: "teal",
      title: allA11yLabels[direction],
      "aria-hidden": "false"
    }));
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    "aria-label": ariaLabel,
    "aria-live": ariaLive,
    className: classNames('lmig-Pagination', className)
  }, rest), /*#__PURE__*/React.createElement("nav", {
    className: "lmig-Pagination-nav",
    id: id,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement("div", {
    ref: navPagesRef,
    className: "lmig-Pagination-nav-pages"
  }, getButtons('previous'), pageArray().map(function (pageItem, i) {
    var isCurrent = pageItem === page + 1;
    return /*#__PURE__*/React.createElement("button", {
      key: "page-".concat(i + 1),
      "aria-label": pageItem && pageItem === '...' ? null : "".concat(allA11yLabels.page, " ").concat(pageItem),
      "aria-disabled": pageItem && pageItem === '...',
      type: "button",
      "aria-current": isCurrent,
      className: classNames('lmig-Pagination-nav-pages-button', isCurrent && 'is-active'),
      disabled: pageItem && pageItem === '...',
      onClick: function onClick(e) {
        return handlePageChange(e, pageItem - 1, itemsPerPage);
      }
    }, pageItem);
  }), getButtons('next'), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: "lmig-Pagination-nav-pages--highlight",
    style: _objectSpread({}, activePosition)
  }))), showItemsPerPage && /*#__PURE__*/React.createElement("div", {
    className: "lmig-Pagination--items-per-page"
  }, /*#__PURE__*/React.createElement("span", {
    id: "".concat(uniqueID, "-items-per-page-label")
  }, allVisualLabels.perPage), /*#__PURE__*/React.createElement(Select, {
    "aria-labelledby": allVisualLabels.perPage,
    defaultValue: itemsPerPage.toFixed(),
    onChange: function onChange(e) {
      return handlePageChange(e, page, parseInt(e.target.value, 10));
    },
    id: "select--items-per-page",
    labelVisual: allVisualLabels.perPage
  }, itemsPerPageOptions.map(function (itemOption) {
    return /*#__PURE__*/React.createElement(SelectOption, {
      key: "option-".concat(itemOption),
      "aria-label": "option-".concat(itemOption),
      value: itemOption.toFixed()
    }, itemOption);
  }))));
};
Pagination.propTypes = {
  /** Add a custom ID to this element. */id: _pt.string,
  /** Add custom classes to this element. */className: _pt.string,
  /** Index of selected page, starting at 0.
     * @default 0
     */
  page: _pt.number.isRequired,
  /** Total number of items to be counted in pagination. */itemCount: _pt.number.isRequired,
  /** Number of items per page.
     * @default 10
     */
  itemsPerPage: _pt.number,
  /** Determines whether to show the "items per page" drop-down.
     * @default true
     */
  showItemsPerPage: _pt.bool,
  /** Determines whether to show text labels in the "previous" and "next" buttons.
     * @default true
     */
  withWords: _pt.bool,
  /** Text to be displayed in the component.
     * @default "{ next: 'next', previous: 'previous', perPage: 'Items per page' }"
     */
  visualLabels: _pt.shape({
    next: _pt.node,
    previous: _pt.node,
    perPage: _pt.node
  }),
  /** Text to be provided to screen readers.
     * @default "{ next: 'Next page', previous: 'Previous page', page: 'page' }"
     */
  a11yLabels: _pt.shape({
    next: _pt.string,
    previous: _pt.string,
    page: _pt.string
  }),
  /** Used to inform assistive technology users of changes to content
     * @default 'polite'
     */
  'aria-live': _pt.oneOf(['off', 'polite', 'assertive']),
  /** Options to show in the "items per page" drop-down.
     * @default '[10, 25, 50]'
     */
  itemsPerPageOptions: _pt.arrayOf(_pt.number),
  /** Event fired when the page or number of items is changed. Receives an object with: `originalEvent`, `page`, `itemsPerPage`. The exported type `PaginationChangeEvent` describes this object. */onChange: _pt.func,
  /**
     * @default 'Pagination'
     */
  'aria-label': _pt.string
};